import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { OutletDescription } from './types'

type Status = 'idle' | 'fetching' | 'error' | 'success'

interface OutletState {
  status: Status
  data: OutletDescription | null
  errorMessage: string | null
  isLoading: boolean
}

// --- INITAL STATE --- //

export const initialState: OutletState = {
  status: 'idle',
  errorMessage: null,
  data: null,
  isLoading: false,
}

// --- SLICE --- //

export const slice = createSlice({
  name: 'outlet',
  initialState,
  reducers: {
    reset: (state) => {
      state.status = 'idle'
      state.errorMessage = null
      state.data = null
      state.isLoading = false
    },
    loadStart: (state) => {
      state.status = 'fetching'
      state.errorMessage = null
    },
    loadFail: (state, { payload }: PayloadAction<string>) => {
      state.status = 'error'
      state.errorMessage = payload
    },
    loadSuccess: (state, { payload }: PayloadAction<OutletDescription>) => {
      state.status = 'success'
      state.errorMessage = null
      state.data = payload
    },
    toggleEnabledOutletStart: (state) => {
      state.isLoading = true
    },
    toggleEnabledOutletFail: (state) => {
      state.isLoading = false
    },
    toggleEnabledOutletSuccess: (state) => {
      state.isLoading = false
      if (state.data) {
        state.data.is_available_for_orders = !state.data.is_available_for_orders
      }
    },
  },
})
